import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledOptions = styled(StyledFlex)`
   z-index: 1;
   width: 100%;
`;

StyledOptions.displayName = 'StyledOptions';
